import { ReactNode } from "react";
import { leaderboardPrizeDesktopSplitWidth } from "../../pages/leaderboard";

interface ILeaderboardPrizeProps {
  descriptionComponent: ReactNode;
  cardContentComponent: ReactNode;
  style?: React.CSSProperties;
}

const LeaderboardPrize = ({
  descriptionComponent,
  cardContentComponent,
  style,
}: ILeaderboardPrizeProps) => (
  <div className="prizeContainer" style={style}>
    <p className="descriptionContainer">{descriptionComponent}</p>

    {cardContentComponent}

    <style jsx>{`
      .prizeContainer {
        min-width: 100%;
        flex-shrink: 1;
        padding: 0.5em;
      }

      .descriptionContainer {
        text-align: center;
        font-weight: 600;
        font-size: 1.2em;
        height: 110px;
        padding: 0;
      }

      @media (min-width: 400px) {
        .descriptionContainer {
          height: 90px;
          padding: 0;
        }
      }

      @media (min-width: 500px) {
        .descriptionContainer {
          height: 80px;
          padding: 0;
        }
      }

      @media (min-width: 675px) {
        .descriptionContainer {
          height: 60px;
          padding: 0;
        }
      }

      @media (min-width: 700px) {
        .descriptionContainer {
          height: 100px;
        }
      }

      @media (min-width: 900px) {
        .descriptionContainer {
          height: 90px;
        }
      }

      @media (min-width: 1000px) {
        .descriptionContainer {
          height: 70px;
        }
      }

      @media (min-width: ${leaderboardPrizeDesktopSplitWidth}) {
        .prizeContainer {
          min-width: auto;
          width: 49%;
          max-width: 500px;
        }
      }
    `}</style>
  </div>
);

export default LeaderboardPrize;
